export default __webpack_public_path__ + "static/media/logo-desktop.aeb0e328.png";